/* eslint-disable react/prop-types */
import {Component} from 'react';

import styles from './portal-loading.component.module.scss';

export interface PortalLoadingProps {
    /** Optional status text shown next to the spinner. */
    message?: string;
}

/**
 * Initial-fetch loading state used on every portal page.
 *
 * Renders a subtle accent spinner plus a 2-card skeleton grid so the
 * page reserves its visual rhythm while data is in flight (this avoids
 * a layout "pop" when the real content arrives). Matches §7.0 tokens.
 */
export default class PortalLoading extends Component<PortalLoadingProps> {
    render() {
        const {message} = this.props;
        return (
            <div
                className={styles.wrap}
                role="status"
                aria-live="polite"
                data-testid="portal-loading"
            >
                <div className={styles.statusRow}>
                    <span className={styles.spinner} aria-hidden="true" />
                    <span>{message ?? 'Loading…'}</span>
                </div>
                <div className={styles.grid}>
                    <div className={styles.card} aria-hidden="true">
                        <div
                            className={`${styles.skeletonLine} ${styles.skeletonHeading}`}
                        />
                        <div className={`${styles.skeletonLine} ${styles.skeletonLong}`} />
                        <div className={`${styles.skeletonLine} ${styles.skeletonShort}`} />
                    </div>
                    <div className={styles.card} aria-hidden="true">
                        <div
                            className={`${styles.skeletonLine} ${styles.skeletonHeading}`}
                        />
                        <div className={`${styles.skeletonLine} ${styles.skeletonLong}`} />
                        <div className={`${styles.skeletonLine} ${styles.skeletonShort}`} />
                    </div>
                </div>
                <span className={styles.srOnly}>Loading content</span>
            </div>
        );
    }
}
